import { jsxs as V, jsx as r } from "react/jsx-runtime";
import * as d from "react";
import { cn as x } from "../../../lib/utils.js";
import { Minus as E, Plus as q } from "lucide-react";
import { Button as k } from "../button/Button.js";
const F = d.forwardRef(({ className: N, value: n, onChange: t, min: a, max: s, step: l = 1, label: u, error: i, helperText: I, showControls: o = !0, variant: v = "default", size: U = "md", precision: g, prefix: m, suffix: p, disabled: b, id: z, ...h }, D) => {
  const w = z || d.useId(), [c, f] = d.useState(n !== void 0 ? n : h.defaultValue || 0);
  d.useEffect(() => {
    n !== void 0 && f(n);
  }, [n]);
  const M = (e) => g !== void 0 ? e.toLocaleString("en-US", { minimumFractionDigits: g, maximumFractionDigits: g }) : e.toLocaleString("en-US"), R = (e) => {
    const y = e.replace(/[^0-9.-]/g, ""), S = parseFloat(y);
    return isNaN(S) ? 0 : S;
  }, j = (e) => {
    const y = R(e.target.value);
    f(y), t == null || t(y);
  }, L = () => {
    const e = Math.min((c || 0) + l, s !== void 0 ? s : 1 / 0);
    f(e), t == null || t(e);
  }, P = () => {
    const e = Math.max((c || 0) - l, a !== void 0 ? a : -1 / 0);
    f(e), t == null || t(e);
  }, $ = {
    sm: "h-8 text-xs",
    md: "h-10 text-sm",
    lg: "h-12 text-base"
  }, B = {
    default: "border border-border-color bg-bg-surface rounded-lg",
    minimal: "border-0 border-b-2 border-border-color bg-transparent rounded-none",
    enclosed: "border-0 bg-bg-muted rounded-lg"
  };
  return V("div", { className: "w-full space-y-1.5", children: [u && r("label", { htmlFor: w, className: "block text-sm font-medium text-text-primary", children: u }), V("div", { className: "relative", children: [m && r("span", { className: "absolute left-3 top-1/2 -translate-y-1/2 text-sm text-text-secondary", children: m }), o && r(k, { type: "button", variant: "ghost", size: "sm", onClick: P, disabled: b || a !== void 0 && c <= a, className: x("absolute left-0 top-0 h-full rounded-r-none border-r border-border-color", m && "left-8"), children: r(E, { className: "h-3 w-3" }) }), r("input", { ref: D, id: w, type: "text", value: M(c), onChange: j, min: a, max: s, step: l, disabled: b, className: x("w-full text-center transition-all duration-300 ease-luxury", "focus:outline-none focus:ring-2 focus:ring-lpr-gold/50 focus:border-lpr-gold", "placeholder:text-text-secondary", "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none", $[U], B[v], o && "px-12", m && !o && "pl-10", p && !o && "pr-10", i && "border-lpr-red focus:ring-lpr-red/50", b && "opacity-50 cursor-not-allowed", N), ...h }), o && r(k, { type: "button", variant: "ghost", size: "sm", onClick: L, disabled: b || s !== void 0 && c >= s, className: x("absolute right-0 top-0 h-full rounded-l-none border-l border-border-color", p && "right-8"), children: r(q, { className: "h-3 w-3" }) }), p && r("span", { className: "absolute right-3 top-1/2 -translate-y-1/2 text-sm text-text-secondary", children: p })] }), (i || I) && r("p", { className: x("text-xs", i ? "text-lpr-red" : "text-text-secondary"), children: i || I })] });
});
F.displayName = "NumberInput";
const A = d.forwardRef(({ currency: N = "USD", locale: n = "en-US", ...t }, a) => r(F, { ref: a, prefix: (() => {
  var l;
  try {
    return ((l = new Intl.NumberFormat(n, {
      style: "currency",
      currency: N
    }).formatToParts(0).find((u) => u.type === "currency")) == null ? void 0 : l.value) || "$";
  } catch {
    return "$";
  }
})(), precision: 2, ...t }));
A.displayName = "CurrencyInput";
export {
  A as CurrencyInput,
  F as NumberInput
};
//# sourceMappingURL=NumberInput.js.map
